export type NavigateTo = (string) => void;
import { Mask } from '@core/app/scripts/services/mask';

/*
 * Service navigateTo
 */
angular
  .module('posApp')
  .factory(
    'navigateTo',
    (
      $location: ng.ILocationService,
      $rootScope: ng.IRootScopeService,
      mask: Mask,
    ) => {
      return (view) => {
        mask.hide();

        // get 'route' from 'pos.route#/eos-edit' or 'pos.route'
        const page = view.replace('pos.route#', '');

        $rootScope.$broadcast('navigateTo', page);

        $location.url('/' + view);
      };
    },
  );
